import { DeferredPromise, pDefer } from '@naturalcycles/js-lib/promise'
import { PropsWithChildren, useMemo, useState } from 'react'
import Modal from '../components/Modal'
import { Button } from '@bm-js/atlascloud-ui'
import { ConfirmContext, ConfirmInput } from '../contexts/Confirm.context'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

export const ConfirmProvider = ({ children }: PropsWithChildren) => {
  const { tr } = useTr()
  const [promise, setPromise] = useState<DeferredPromise<boolean> | null>(null)
  const [input, setInput] = useState<ConfirmInput>('')

  const {
    message,
    title = tr(TrKey.confirmProviderDefaultTitle),
    proceedText = tr(TrKey.confirmProviderDefaultProceed),
    abortText = tr(TrKey.cancel),
  } = useMemo(() => {
    if (typeof input === 'string') {
      return { message: input }
    }
    return input
  }, [input])

  const confirm = (input: ConfirmInput) => {
    setInput(input)
    const promise = pDefer<boolean>()
    setPromise(promise)
    return promise
  }

  const proceed = () => {
    if (!promise) return
    promise.resolve(true)
    setPromise(null)
  }

  const abort = () => {
    if (!promise) return
    promise.resolve(false)
    setPromise(null)
  }

  return (
    <ConfirmContext.Provider value={confirm}>
      {promise && (
        <Modal onClose={abort} title={title} className='w-1/3'>
          <p>{message}</p>
          <div className='flex justify-end gap-2 mt-4'>
            <Button onClick={abort}>{abortText}</Button>
            <Button danger onClick={proceed}>
              {proceedText}
            </Button>
          </div>
        </Modal>
      )}
      {children}
    </ConfirmContext.Provider>
  )
}
